import { useOnboardingContext } from '../contexts/Onboarding';
import { pathname, mainOnboardingUrls } from '../utils';

const extraOnboardingPages = pathname.onboarding.extras;

function getOnboardingPageByStepNumber(activeStep: number) {
  let pages = null;
  if (mainOnboardingUrls.includes(window.location.pathname)) {
    pages = pathname.onboarding.main;
  } else {
    const extraPages = Object.values(extraOnboardingPages);
    return extraPages.find((page) => page.url === window.location.pathname);
  }
  let currentPage = null;
  for (const page in pages) {
    if (pages[page].stepInStepper === activeStep) {
      currentPage = pages[page];
    }
  }
  return currentPage;
}

function getOnboardingPageByUrl() {
  const currentPage = Object.values({
    ...pathname.onboarding.main,
    ...pathname.onboarding.extras,
  }).find((onboardingPage) => onboardingPage?.url === window.location.pathname);
  return currentPage;
}

export function useGetOnboardingPage() {
  const { activeStep, setPageChanged, setStepInStepper } =
    useOnboardingContext();
  let currentPage = null;
  if (activeStep) {
    currentPage = getOnboardingPageByStepNumber(activeStep);
  } else {
    currentPage = getOnboardingPageByUrl();
  }
  if (!currentPage) return;
  if (currentPage?.stepInStepper) {
    setStepInStepper(currentPage.stepInStepper);
  }
  setPageChanged(false);
  return currentPage;
}
